export const PageHeader = ({ eyebrow, title, description, actions }) => (
  <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8 fade-up">
    <div>
      <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#E60000]">{eyebrow}</div>
      <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight text-[#111] mt-1" data-testid="page-title">{title}</h1>
      {description && <p className="text-sm sm:text-base text-gray-600 mt-2 max-w-2xl">{description}</p>}
    </div>
    {actions && <div className="flex gap-2 flex-wrap">{actions}</div>}
  </div>
);

export const Panel = ({ title, children, className = "", right, testId }) => (
  <section className={`bg-white border border-[#E5E7EB] rounded-lg ${className}`} data-testid={testId}>
    {title && (
      <div className="flex items-center justify-between px-5 py-4 border-b border-[#E5E7EB]">
        <h3 className="font-heading font-bold text-[#111]">{title}</h3>
        {right}
      </div>
    )}
    <div className="p-5">{children}</div>
  </section>
);

export const StatCard = ({ label, value, sub, icon: Icon, testId, delay = 0 }) => (
  <div className="bg-white border border-[#E5E7EB] rounded-lg p-5 border-l-4 border-l-[#E60000] fade-up hover:-translate-y-0.5 transition-transform duration-200" style={{ animationDelay: `${delay}ms` }} data-testid={testId}>
    <div className="flex items-start justify-between">
      <div className="text-[11px] font-bold uppercase tracking-[0.14em] text-gray-500">{label}</div>
      {Icon && <Icon className="w-4 h-4 text-[#E60000]" />}
    </div>
    <div className="font-heading text-3xl font-extrabold tracking-tight text-[#111] mt-3">{value}</div>
    {sub && <div className="text-xs text-gray-500 mt-1">{sub}</div>}
  </div>
);

export const BrandButton = ({ children, className = "", variant = "red", ...props }) => {
  const styles = {
    red: "bg-[#E60000] text-white hover:bg-[#CC0000] active:bg-[#B30000]",
    dark: "bg-[#111] text-white hover:bg-[#262626]",
    outline: "bg-white text-[#111] border border-[#D1D5DB] hover:border-[#E60000] hover:text-[#E60000]",
  };
  return (
    <button className={`inline-flex items-center justify-center gap-2 h-10 px-4 rounded-md text-sm font-semibold transition-colors duration-200 disabled:opacity-50 disabled:pointer-events-none ${styles[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
};

export const StandingBadge = ({ standing, testId }) => {
  if (!standing) return <span className="text-xs text-gray-400">—</span>;
  const good = standing === "Good Standing";
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border text-[11px] font-bold whitespace-nowrap ${good ? "bg-emerald-50 text-emerald-700 border-emerald-300" : "bg-[#FFF0F0] text-[#B30000] border-[#E60000]/40"}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${good ? "bg-emerald-500" : "bg-[#E60000]"}`} />{standing}
    </span>
  );
};

export const StatusPill = ({ status }) => {
  const map = { Completed: "bg-emerald-50 text-emerald-700 border-emerald-200", Paid: "bg-emerald-50 text-emerald-700 border-emerald-200", Free: "bg-yellow-100 text-yellow-800 border-yellow-300", "Part Paid": "bg-amber-50 text-amber-700 border-amber-200", Unpaid: "bg-red-50 text-red-700 border-red-200", Refunded: "bg-gray-100 text-gray-700 border-gray-300", Pending: "bg-amber-50 text-amber-700 border-amber-200", Voided: "bg-red-50 text-red-700 border-red-200" };
  return <span className={`inline-flex px-2 py-0.5 rounded-full border text-[11px] font-semibold ${map[status] || "bg-gray-50 text-gray-600 border-gray-200"}`}>{status}</span>;
};
